// src/components/ServiceWorkerHandler.jsx

import { useEffect, useState } from 'react';
import { register } from '../serviceWorkerRegistration';

const ServiceWorkerHandler = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  // ⚡ Handle network status
  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

     
  // useEffect(() => {
  //   console.log("🚨 Update register!");
  //   register({
      
  //     onUpdate: (registration) => {
  //       if (registration && registration.waiting) {
  //         setWaitingWorker(registration.waiting);
  //         setIsUpdateAvailable(true);
  //       }
  //     },
  //   });
  // }, []);

//   const updateApp = () => {
//   console.log("🚨 Update found!");
//   if (waitingWorker) {
//     console.log('Worker state:', waitingWorker.state);
 
//     waitingWorker.addEventListener('statechange', (e) => {
//       console.log('SW state change:', e.target.state);
//       if (e.target.state === 'activated') {
//         window.location.reload();
//       }
//     });
 
//     waitingWorker.postMessage({ type: 'SKIP_WAITING' });
 
//     if (waitingWorker.state === 'activated') {
//       console.log('Already activated, reloading now');
//       window.location.reload();
//     }
//   }
// };

  return (
    <>
      {isOffline && (
        <div style={{ 
           position: 'fixed',
          top: 0,
          left: 0,
           width: '100vw',
           height: '100vh',
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
      }}>
        <div
          style={{
           
           background: 'red',
        color: 'white',
        padding: '1rem 2rem',
        borderRadius: '8px',
        fontSize: '1.2rem',
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
           
          }}
        >
          ⚠️ You are offline. Some features may not work.
        </div>
        </div>
      )}


       {/* {isUpdateAvailable && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            width: '100%',
            background: '#333',
            color: '#fff',
            padding: '10px',
            textAlign: 'center',
            zIndex: 10000,
          }}
        >
          🆕 A new version is available.
          <button
            onClick={updateApp}
            style={{
              marginLeft: '10px',
              background: '#4caf50',
              color: 'white',
              border: 'none',
              padding: '6px 12px',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Refresh
          </button>
        </div>
      )} */}
    </>
  );
};

export default ServiceWorkerHandler;
